import {
  Box,
  Button,
  Collapse,
  Container,
  Grid,
  Link,
  Stack,
  Step,
  StepButton,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import CinemaCard from "./components/cinemaCard";
import CinemaContent from "./components/cinemaContent";
import img from "../../images/jpg/xl_1745960_cc176006.jpg";
import testBg from "../../images/jpg/traumatic.jpg";
import { useDispatch, useSelector } from "react-redux/es/exports";
import { SplashContext } from "../layout/layout";
import MovieCard from "../../components/MovieCard";
import { TermsDialog } from "../terms_conditions/terms";
import Receipt from "./components/receipt";
import Payment from "./components/payment";
import { useParallax } from "react-scroll-parallax";
import { useParams } from "react-router-dom";
import lorem from "../../utilities/loremIpsum";
import imageLoader from "../../utilities/imageLoader";
import { scroller as scroll, Element } from "react-scroll";
import "./moviePage.scss";
import { getHrsMins } from "./utilities/get_hrs_mins";
import ReactPlayer from "react-player";
import paymentFunction, {
  createPayload,
  payWithWallet,
} from "./utilities/payment_services";
import getMovies from "../home_page/utilities/getMovies";
import { setMovies } from "../../redux/slices/moviesSlice";
import getCinemas from "../home_page/utilities/getCinemas";
import { receiptContent } from "./utilities/email_service";
import dayjs from "dayjs";

//For passing data to the cinema card component and the theatre table
const SeatsContext = createContext();

const MoviePage = () => {
  /* #region  Redux */
  const dispatch = useDispatch();
  const _movieList = useSelector((state) => state.moviesReducer.movies);
  const _cinemasList = useSelector((state) => state.cinemasReducer.cinemas);
  /* #endregion */

  /* #region  styles and media queries */
  const theme2 = useTheme();
  const isMobile = useMediaQuery(theme2.breakpoints.down("sm"));
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const spanFontSizes2 = {
    fontSize: { lg: "1rem", md: "0.875rem", sm: "0.75rem", xs: "0.75rem" },
  };
  /* #endregion */

  /* #region  Ui controllers */
  const splashScreen = useContext(SplashContext);
  const [receiptImgLoaded, setReceiptImgLoaded] = useState({
    loaded: false,
    display: "none",
  });
  const [fullDescription, toggleDescription] = useState(false);
  const [paymentComplete, setPayComplete] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [expandedCard, setExpanedCard] = useState(-1);
  const [termsDialogOpen, setTermsDialog] = useState(false);
  const [trailerPlaying, setTrailerPlaying] = useState(true);
  const onSeatSelect = (seat, price, code, description) => {
    let obj = { ...selectedSeats };
    obj[seat] = {
      SeatNumber: seat,
      SeatPrice: parseInt(price),
      TicketCode: code,
      SeatDescription: description,
    };
    setSelectedSeats(obj);
    setTotalCost(
      Object.values(obj)
        .map((seat) => seat.SeatPrice)
        .reduce((prev, curr) => prev + curr)
    );
  };
  const onSeatDeselect = (seat) => {
    let obj = { ...selectedSeats };
    delete obj[seat];
    setSelectedSeats(obj);
    setTotalCost(
      Object.values(obj).length > 0
        ? Object.values(obj)
            .map((seat) => seat.SeatPrice)
            .reduce((prev, curr) => prev + curr)
        : 0
    );
  };
  const handleExpand = (index) => {
    expandedCard === index ? setExpanedCard(-1) : setExpanedCard(index);
    setSelectedSeats([]);
  };
  const openPayment = () => {
    setActiveStep(1);
  };
  const scrollToBook = () => {
    scroll.scrollTo("bookSeats", {
      Duration: 1000,
      smooth: true,
      offset: -50,
    });
    //scroll.scrollToBottom();
  };
  const { ref } = useParallax({
    speed: isMobile ? 0 : -50,
  });
  /* #endregion */

  /* #region  Page content */
  const [cinemas, setCinemas] = useState([]);
  const [movieDetails, setMovieDetails] = useState({
    MovieName: "Traumatic",
    genre: ["Horror"],
    Duration: "2hrs",
    CensorRating: 4,
    MovieTrailer: "https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1",
    MovieImageSmall: testBg,
    MovieImageBig: testBg,
    Description: lorem.generateSentences(4),
  });
  const [
    /**Used when there is no cinema present in then url params */
    selectedCinemaId,
    setSelectedCinemaId,
  ] = useState("");
  const [
    /** Used when there is a cinema present in the url params */
    cinemaDetails,
    setCinemaDetails,
  ] = useState({});
  const [recommendedMovies, setRecommended] = useState([]);
  const [promoAndCost, setPromoAndCost] = useState({
    PromoCode: "",
    PromoAmount: 0,
    MovieTicketCost: 0,
  });
  /* #endregion */

  /* #region  Order details */
  const [selectedSeats, setSelectedSeats] = useState({});

  const [totalCost, setTotalCost] = useState(0);
  const [seatPrice, setSeatPrice] = useState(0);
  const [showDate, setShowDate] = useState("");
  const [experience, setExperience] = useState("2D");
  const [cinema_Name, setCinemaName] = useState("Not selected");
  const [show, setShow] = useState("Not selected");
  const [rContent, setRContent] = useState({});
  const [markup, setMarkup] = useState(0);
  const [_phone, setPhone] = useState("");
  const [BookingID, setBookingID] = useState("");

  /* #endregion */

  /* #region  Api calls and initialization */
  const { movieId, cinemaId } = useParams();

  /**To set state and props for various components with the movie's details
   * @param {Movie[]} movies array of movies
   * @param {void} resolve callback function
   */
  const setMovie = (movies, resolve) => {
    let movie = movies.find((movie) => movie.MovieID === movieId);

    if (movie) {
      let obj = {
        MovieName: movie.MovieName,
        genre: [""],
        Duration: movie.Duration,
        CensorRating: movie.CensorRating,
        MovieTrailer: movie.MovieTrailer,
        MovieImageSmall: movie.MovieImageSmall,
        MovieImageBig: movie.MovieImageBig,
        Description: movie.Description,
        Actors: movie.Actors,
        Director: movie.Director,
      };

      setMovieDetails(obj);
      imageLoader(movie.MovieImageSmall).then(() => {
        setReceiptImgLoaded({
          loaded: true,
          display: "block",
        });
        resolve(movie);
      });
    } else {
      resolve();
    }
  };

  /**Calls the payment service then updates ui */
  const pay = ({
    customerEmail,
    content = receiptContent(),
    paymentPayload,
    phone,
    paymentMethod,
    WalletUniqueID = "",
  }) =>
    new Promise((resolve, reject) => {
      let payload = createPayload({
        Markup: markup,
        MovieID: movieId,
        MovieProviderID: cinemaDetails.MovieProviderID ?? selectedCinemaId,
        MovieTicketCost: Object.values(selectedSeats)
          .map((seat) => seat.SeatPrice)
          .reduce((a, b) => a + b),
        PromoAmount: promoAndCost.PromoAmount,
        PromoCode: promoAndCost.PromoCode,
        ScreenID: show.ScreenID,
        Seats: selectedSeats,
        ShowDate: showDate,
        ShowID: show.ShowID,
        WalletUniqueID,
      });
      if (paymentMethod === "WALLET") {
        payWithWallet(payload, paymentPayload, content, customerEmail, phone)
          .then((response) => {
            setActiveStep(2);
            setPayComplete(true);
            setRContent(content);
            setPhone(phone);
            setBookingID(response.BookingID);
            resolve(response.BookingID);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      } else {
        paymentFunction(payload, paymentPayload, content, customerEmail, phone)
          .then((response) => {
            setActiveStep(2);
            setPayComplete(true);
            setRContent(content);
            setPhone(phone);
            setBookingID(response.BookingID);
            resolve(response.BookingID);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });

  /**Takes a list of cinemas from api or redux then looks for the ones which are showing
   * the selected movie
   */
  const filterCinemas = (movie, cinemas) => {
    if (!cinemaId) {
      let MovieProviderIDs = movie.ShowTimes.map(
        (showTime) => showTime.MovieProviderID
      );
      setCinemas(
        cinemas.filter((cinema) =>
          MovieProviderIDs.includes(cinema.MovieProviderID)
        )
      );
    } else {
      let details = cinemas.find((item) => item.MovieProviderID === cinemaId);
      if (details) {
        setCinemaDetails(details);
        setCinemaName(details.Name);
      } else {
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    //get movie details
    const setDetails = () =>
      new Promise((resolve, reject) => {
        if (_movieList.length > 0) {
          setMovie(_movieList, resolve);
          setRecommended(getRecommendedMovies(_movieList));
        } else {
          getMovies()
            .then((movies) => {
              dispatch(setMovies(movies.map((movie) => ({ ...movie }))));
              setMovie(movies, resolve);
              setRecommended(getRecommendedMovies(movies));
            })
            .catch(reject);
        }
      });

    //get recommended movies
    const getRecommendedMovies = (movieList = []) => {
      let copy = movieList ? [...movieList] : [];
      return copy.length > 0
        ? copy.sort(() => 0.5 - Math.random()).slice(0, 4)
        : [];
    };

    const getData = () =>
      new Promise((resolve, reject) => {
        setDetails()
          .then((movie) => {
            if (_cinemasList.length > 0) {
              filterCinemas(movie, _cinemasList);
            } else {
              getCinemas()
                .then((cinemas) => filterCinemas(movie, cinemas))
                .catch(reject);
            }

            resolve();
          })
          .catch(reject);
      });

    splashScreen(getData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movieId, cinemaId]);
  /* #endregion */

  /* #region  Component props */
  const receiptProps = {
    receiptImgLoaded,
    img,
    movieDetails,
    cinema_Name,
    showDate,
    experience,
    show,
    selectedSeats,
    rContent,
    BookingID,
    phone: _phone,
  };
  const paymentProps = {
    totalCost,
    cinema_Name,
    showDate,
    experience,
    show,
    pay,
    selectedSeats,
    MovieName: movieDetails.MovieName,
    movieId,
    MovieProviderID: cinemaId ? cinemaId : selectedCinemaId,
    setActiveStep,
  };
  const cinemaContentProps = {
    MovieProviderID: cinemaId,
    MovieID: movieId,
    ShowDate: dayjs().format("DD MMM"),
    movieDetails,
  };
  /* #endregion */

  return (
    <Box>
      <Stack>
        <Box
          sx={{
            height: {
              xs: "80vh",
              sm: "100vh",
            },
            position: "relative",
          }}
        >
          {
            //#region Background
          }
          <Box
            sx={{
              width: "100%",
              height: {
                xs: "80vh",
                sm: "100vh",
              },
              position: "absolute",
              backgroundColor: "black",
              backgroundSize: "50%",
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "100%",
              backgroundPositionY: "50%",
              overflow: "hidden",
            }}
          >
            <Stack
              direction="row"
              sx={{
                width: "100%",
                height: "100%",
              }}
            >
              <Box sx={{ flexGrow: { xs: 0, md: 1 }, height: "100%" }} />
              <Box
                ref={ref}
                sx={{
                  flexGrow: 2,
                  height: "115%",
                  backgroundImage: {
                    xs: `linear-gradient(180deg, rgba(0,0,0,.7) 0,  rgba(0,0,0,.7) 100%), url(${movieDetails.MovieImageBig})`,
                    md: `linear-gradient(90deg, rgba(0,0,0,1) 0, rgba(0,0,0,0) 40%, rgba(0,0,0,0) 60%, rgba(0,0,0,0) 100%), url(${movieDetails.MovieImageBig})`,
                  },
                  backgroundSize: "cover",
                  backgroundPosition: {
                    xs: "0 0",
                    md: "50% 50%",
                  },
                  backgroundRepeat: "no-repeat",
                }}
              ></Box>
            </Stack>
          </Box>
          {
            //#endregion
          }
          {
            //#region trailer,description etc
          }
          <Grid
            container
            spacing={1}
            sx={{
              pt: "5vh",
              height: {
                xs: "80vh",
                sm: "100vh",
              },
              position: "absolute",
            }}
          >
            <Grid
              item
              xs={12}
              md={7}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "center",
                  sm: "end",
                },
              }}
            >
              <Stack
                spacing={2}
                sx={{
                  width: "100%",
                  alignItems: "center",
                  height: {
                    xs: "calc(80vh - 10vh)",
                    sm: "calc(100vh - 10vh)",
                  },
                  overflowY: "auto",
                }}
                className="desc"
              >
                {movieDetails.MovieTrailer ? (
                  <ReactPlayer
                    className="trailerIframe"
                    width={"90%"}
                    height={"auto"}
                    controls={true}
                    url={movieDetails.MovieTrailer}
                    playing={trailerPlaying}
                    onPause={() => setTrailerPlaying(false)}
                    onPlay={() => setTrailerPlaying(true)}
                    onError={(error) => {
                      // setMovieDetails((prev) => ({
                      //   ...prev,
                      //   MovieTrailer: "",
                      // }));
                    }}
                  />
                ) : (
                  <Stack width={"80%"} alignItems="start">
                    <Box
                      component={"img"}
                      src={movieDetails.MovieImageSmall}
                      height={"40vh"}
                    />
                  </Stack>
                )}
                <Stack
                  sx={{
                    width: "90%",
                    alignItems: "start",
                  }}
                >
                  <Stack
                    direction={{
                      xs: "column",
                      md: "row",
                    }}
                    spacing={2}
                    alignItems={{ xs: "start", md: "center" }}
                  >
                    <Typography
                      variant="h4"
                      color={"white"}
                      sx={{ display: "flex", alignItems: "center" }}
                      fontSize={{
                        xs: "1.5rem",
                        sm: "2.125rem",
                      }}
                    >
                      {movieDetails.MovieName}
                    </Typography>
                    <Button variant="contained" onClick={() => scrollToBook()}>
                      Book now
                    </Button>
                  </Stack>
                  <br />
                  <Typography
                    component="span"
                    color={"white"}
                    sx={{
                      ...spanFontSizes1,
                      whiteSpace: "pre-wrap",
                      fontWeight: 300,
                    }}
                  >
                    {movieDetails.genre.join(", ")}
                  </Typography>
                  <Typography
                    component="span"
                    color={"white"}
                    sx={{
                      ...spanFontSizes1,
                      whiteSpace: "pre-wrap",
                      fontWeight: 300,
                    }}
                  >
                    {getHrsMins(movieDetails.Duration)}
                  </Typography>
                  {movieDetails.CensorRating && (
                    <>
                      <Typography
                        component={"span"}
                        color="white"
                        sx={{
                          ...spanFontSizes1,
                          whiteSpace: "pre-wrap",
                          fontWeight: 300,
                        }}
                      >
                        Rated: <strong>{movieDetails.CensorRating}</strong>
                      </Typography>
                    </>
                  )}
                  {movieDetails.Actors && (
                    <>
                      <Typography
                        component={"span"}
                        color="white"
                        sx={{
                          ...spanFontSizes1,
                          whiteSpace: "pre-wrap",
                          fontWeight: 300,
                        }}
                      >
                        Actors: <strong>{movieDetails.Actors}</strong>
                      </Typography>
                    </>
                  )}
                  {movieDetails.Director && (
                    <>
                      <Typography
                        component={"span"}
                        color="white"
                        sx={{
                          ...spanFontSizes1,
                          whiteSpace: "pre-wrap",
                          fontWeight: 300,
                        }}
                      >
                        Director: <strong>{movieDetails.Director}</strong>
                      </Typography>
                    </>
                  )}

                  {/*Description*/}

                  {false && movieDetails.Description && (
                    <Stack flexGrow={1}>
                      <br />
                      <Typography
                        variant="h5"
                        sx={{
                          whiteSpace: "pre-wrap",
                          fontWeight: 500,
                        }}
                        color="white"
                        fontSize={{
                          xs: "1.25rem",
                          sm: "2.1rem",
                        }}
                      >
                        Description
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          ...spanFontSizes2,
                          whiteSpace: "pre-wrap",
                          fontWeight: 300,
                        }}
                        color="white"
                      >
                        {movieDetails.Description.split(" ").length > 15 ? (
                          <>
                            {fullDescription ? (
                              <>{movieDetails.Description}</>
                            ) : (
                              <>
                                {movieDetails.Description.split(" ")
                                  .slice(0, 15)
                                  .join(" ")}
                                ...
                              </>
                            )}{" "}
                            <Link
                              onClick={() =>
                                toggleDescription(!fullDescription)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              Show {fullDescription ? <>less</> : <>more</>}
                            </Link>
                          </>
                        ) : (
                          <>{movieDetails.Description}</>
                        )}
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
          {
            //#endregion
          }
        </Box>

        {
          //#region Page content
        }
        <Element name="bookSeats">
          <section id="bookSeats">
            <Container maxWidth="lg">
              <Stack spacing={2} sx={{ minHeight: "100vh" }}>
                <Stepper
                  nonLinear
                  activeStep={activeStep}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "80%",
                    },
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "2vh",
                    marginBottom: "2vh",
                  }}
                  alternativeLabel={isMobile}
                >
                  <Step completed={paymentComplete}>
                    <StepLabel>Book seats</StepLabel>
                  </Step>
                  <Step completed={paymentComplete}>
                    <StepLabel>Payment</StepLabel>
                  </Step>
                  <Step>
                    {false && (
                      <StepButton
                        onClick={() => {
                          setActiveStep(2);
                        }}
                      >
                        Receipt
                      </StepButton>
                    )}

                    <StepLabel>Receipt</StepLabel>
                  </Step>
                </Stepper>

                <SeatsContext.Provider
                  value={{
                    openPayment,
                    onSeatSelect,
                    onSeatDeselect,
                    selectedSeats,
                    totalCost,
                    setTotalCost,
                    setSeatPrice,
                    seatPrice,
                    setShowDate,
                    setExperience,
                    setShow,
                    setCinemaName,
                    setTermsDialog,
                    selectedCinemaId,
                    setSelectedCinemaId,
                    setActiveStep,
                    markup,
                    setMarkup,
                    setPromoAndCost,
                  }}
                >
                  {
                    //#region cinemas, seats, shows, seat layout etc
                  }
                  <Collapse in={activeStep === 0}>
                    {cinemaId ? (
                      <Stack spacing={2}>
                        <Typography
                          variant="h4"
                          fontSize={{
                            xs: "1.5rem",
                            sm: "2.125rem",
                          }}
                        >
                          {cinemaDetails.Name}
                        </Typography>
                        <CinemaContent
                          {...cinemaContentProps}
                          experiences={
                            cinemaDetails.movies
                              ? cinemaDetails.movies.find(
                                  (movie) => movie.MovieID === movieId
                                ).experience
                              : ["2D", "3D"]
                          }
                        />
                      </Stack>
                    ) : (
                      <Stack spacing={2}>
                        <Typography
                          variant="h4"
                          fontSize={{
                            xs: "1.3rem",
                            sm: "2.125rem",
                          }}
                        >
                          Available Cinemas
                        </Typography>

                        {cinemas.map((cinema, index) => (
                          <CinemaCard
                            key={cinema.Name}
                            onExpand={() => {
                              handleExpand(index);
                            }}
                            expanded={expandedCard === index}
                            cinema_Name={cinema.Name}
                            cinema={cinema}
                            movieDetails={movieDetails}
                            MovieID={movieId}
                            // experiences={
                            //   cinema.movies.find(
                            //     (movie) => movie.MovieID === movieId
                            //   ).experience
                            // }
                          />
                        ))}
                      </Stack>
                    )}
                  </Collapse>

                  {
                    //#endregion
                  }
                  {/*Payment*/}
                  <Collapse in={activeStep === 1}>
                    <Payment {...paymentProps} />
                  </Collapse>
                  {/*Receipt*/}
                  <Collapse in={activeStep === 2}>
                    <Receipt {...receiptProps} />
                  </Collapse>
                </SeatsContext.Provider>

                {/*Recommended*/}
                <Typography
                  variant="h5"
                  fontSize={{
                    xs: "1.25rem",
                    sm: "2.1rem",
                  }}
                >
                  Recommended
                </Typography>
                <Stack direction="row" sx={{ flexWrap: "wrap" }}>
                  {recommendedMovies.map((movie, index) => {
                    return (
                      <MovieCard
                        key={movie.MovieID}
                        movieName={movie.MovieName}
                        imgsrc={movie.MovieImageSmall}
                        rating={movie.CensorRating}
                        duration={getHrsMins(movie.Duration)}
                        genre={movie.genre}
                        id={movie.MovieID}
                      />
                    );
                  })}
                </Stack>
              </Stack>
            </Container>
          </section>
        </Element>
        {
          //#endregion
        }
      </Stack>
      {
        //#region Pop ups
      }

      <TermsDialog
        open={termsDialogOpen}
        setOpen={setTermsDialog}
        onAccept={() => openPayment()}
      />
      {
        //#endregion
      }
    </Box>
  );
};
export default MoviePage;
export { SeatsContext };
